import { DownloadIcon } from '../../pages/icons';

const SingleFileRender = (file) => {
  if (typeof file === 'string') {
    const fileExtenstion = file.split('.').pop();
    if (['jpg', 'jpeg', 'png', 'webp'].includes(fileExtenstion.toLowerCase())) {
      return <img style={{ padding: '10px' }} width="120px" height="120px" src={`${process.env.REACT_APP_BASE_URL}/${file}`} alt="" />;
    } else {
      return (
        <a href={`${process.env.REACT_APP_BASE_URL}/${file}`} target="_blank" rel="noreferrer">
          <DownloadIcon style={{ color: 'purple' }} />
        </a>
      );
    }
  }
};

const FilesRender = (files) => {
  if (files && Array.isArray(files)) {
    return (
      <div className="d-flex flex-wrap">
        {files.map((file) => (
          <div className="p-2">{SingleFileRender(file)}</div>
        ))}
      </div>
    );
  } else if (files) {
    return (
      <div className="d-flex">
        <div className="p-2">{SingleFileRender(files)}</div>
      </div>
    );
  } else {
    return null;
  }
};

export default FilesRender;
